import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";

const deleteCorp = async ({ id }: DeleteCorpReqT) =>
  axios.delete(urlMaker(Routes.DELETE_CORP, id));

export const useDeleteCorp = () =>
  useMutation({
    mutationKey: [Keys.DELETE_CORP],
    mutationFn: deleteCorp,
    cacheTime: Infinity,
  });
